import { addErrorLogger } from "./modules/onerror";
import { collapseSection, collapseAndDisableSection, expandAndEnableSection, isCollapsed, expandSection } from "./modules/collapse";
import { bbqPage } from "./bbq-page";
import { noticeCloseButtons } from "./modules/woowommerceWrappers";
import { cookieListeners } from "./modules/cookie";
import shippingZoneChecker from "./modules/shippingZoneChecker";
import { flare } from "@flareapp/flare-client";
import { setupSlider } from "./slider";
import { menuListeners } from "./menuListeners";

if (process.env.NODE_ENV === "production") {
    flare.light("vFfNrqlZSYjpMEbk9siqTWwX4s6Qk6dH");
}

// addErrorLogger();

document.addEventListener("DOMContentLoaded", () => {
    new shippingZoneChecker();

    cookieListeners();
    setupSlider();
    winkelTabs();
    nieuwsActionTabs();
    fixHeight();
    winkelPullTab();
    bbqPage();
    noticeCloseButtons();
    menuListeners();

    const menuButton = document.getElementById("mobile-menu-toggle");
    if (menuButton) {
        menuButton.addEventListener("click", () => {
            [...menuButton.children].forEach((element) => {
                element.classList.remove("delay-150");
                element.classList.add("opacity-0");
            });
            const mobileMenu = document.getElementById("mobile-menu");

            // toggle is true if added, which means the menu is no longer showing
            if (mobileMenu.classList.toggle("opacity-0")) {
                // Menu is removed thus show open button
                document.getElementById("mobile-menu-open").classList.add("delay-150");
                document.getElementById("mobile-menu-open").classList.remove("opacity-0");

                document.body.classList.remove("overflow-hidden");

                mobileMenu.classList.add("pointer-events-none");
            } else {
                // Menu is added thus show close button
                document.getElementById("mobile-menu-close").classList.add("delay-150");
                document.getElementById("mobile-menu-close").classList.remove("opacity-0");

                document.body.classList.add("overflow-hidden");

                mobileMenu.classList.remove("pointer-events-none");
            }
        });
    }

    const verzendContainer = document.getElementById("order_review");

    if (verzendContainer) {
        showShippingMethodOptions();
        verzendContainer.addEventListener("click", () => {
            showShippingMethodOptions();
        });

        jQuery(document).ajaxComplete(function (event, xhr, settings) {
            showShippingMethodOptions();
        });
    }

    [...document.querySelectorAll("[id*='scroll']")].forEach((scrollButton) => {
        let scrollElement = document.getElementById(scrollButton.id.replace("-button", ""));
        scrollButton.addEventListener("click", () => {
            scrollElement.scrollBy(0, 100);
        });
    });

    const leen_bbq_ophalen = document.getElementById("leen_bbq_ophalen");
    if (leen_bbq_ophalen) {
        leen_bbq_ophalen.addEventListener("click", () => {
            if (leen_bbq_ophalen.checked) {
                window.location.href = window.location.href = "?leen_bbq_ophalen=true";
            } else {
                window.location.href = window.location.href = "?leen_bbq_ophalen=false";
            }
        });
    }
});

document.addEventListener("load", () => {
    fixHeight();
});

window.toggle = function (target) {
    const section = document.getElementById(target);
    if (!isCollapsed(section)) {
        collapseSection(section);
    } else {
        expandSection(section);
    }
};

function showShippingMethodOptions() {
    const pickup = document.querySelector("[id*='local_pickup']");
    const sectionBezorg = document.getElementById("bezorgmoment_field");
    const sectionAfhaal = document.getElementById("afhaalmoment_field");
    const sectionAfhaalLocation = document.getElementById("afhaal-picker");

    if (!pickup) {
        collapseAndDisableSection(sectionAfhaal);
        collapseAndDisableSection(sectionAfhaalLocation);
        expandAndEnableSection(sectionBezorg);
        return;
    }

    if (pickup.checked || pickup.type == "hidden") {
        collapseAndDisableSection(sectionBezorg);
        expandAndEnableSection(sectionAfhaal);
        expandAndEnableSection(sectionAfhaalLocation);
    } else {
        collapseAndDisableSection(sectionAfhaalLocation);
        collapseAndDisableSection(sectionAfhaal);
        expandAndEnableSection(sectionBezorg);
    }
}

window.onresize = function () {
    fixHeight();
};

function fixHeight() {
    [...document.querySelectorAll(".height-largest-child")].forEach((element) => {
        var height = 0;

        [...element.children].forEach((child) => {
            if (child.style.display == "none") {
                return;
            }

            if (child.scrollHeight > height) {
                height = child.scrollHeight;
            }
        });

        element.classList.remove("min-h-1600");
        element.classList.remove("md:min-h-835");
        collapseSection(element, height);
    });
}

function winkelPullTab() {
    const winkelPullTab = document.getElementById("winkel-pulltab");
    if (winkelPullTab) {
        winkelPullTab.addEventListener("click", () => {
            document.getElementById("winkel-tab-container").classList.remove("overflow-hidden");

            document.getElementById("winkel-tab").classList.add("-translate-y-full");
        });

        [...document.querySelectorAll(".winkel-pulltab-close")].forEach((closeButton) => {
            closeButton.addEventListener("click", () => {
                document.getElementById("winkel-tab").classList.remove("-translate-y-full");
                sleep(1000).then(() => {
                    document.getElementById("winkel-tab-container").classList.add("overflow-hidden");
                });
            });
        });
    }
}

function winkelTabs() {
    const parkButton = document.getElementById("park-button");
    const pleinButton = document.getElementById("plein-button");
    const bosButton = document.getElementById("bos-button");

    if (parkButton) {
        parkButton.addEventListener("click", () => {
            // change color tabs
            bosButton.classList.remove("bg-yellow");
            pleinButton.classList.remove("bg-yellow");
            parkButton.classList.add("bg-yellow");
            // switch out content
            showPark();
        });
    }

    if (pleinButton) {
        pleinButton.addEventListener("click", () => {
            // change color tabs
            bosButton.classList.remove("bg-yellow");
            parkButton.classList.remove("bg-yellow");
            pleinButton.classList.add("bg-yellow");
            // switch out content
            showPlein();
        });
    }

    if (bosButton) {
        bosButton.addEventListener("click", () => {
            // change color tabs
            pleinButton.classList.remove("bg-yellow");
            parkButton.classList.remove("bg-yellow");
            bosButton.classList.add("bg-yellow");
            // switch out content
            showBos();
        });
    }

    const pleinButtonMobile = document.getElementById("plein-button-mobile");
    const parkButtonMobile = document.getElementById("park-button-mobile");
    const bosButtonMobile = document.getElementById("bos-button-mobile");

    if (pleinButtonMobile) {
        pleinButtonMobile.addEventListener("click", () => {
            [parkButtonMobile, bosButtonMobile].forEach((otherButton) => {
                resetMobileButton(otherButton);
            });
            pleinButtonMobile.classList.add("bg-yellow");
            pleinButtonMobile.classList.add("rounded-tr");
            pleinButtonMobile.classList.add("w-1/5");
            pleinButtonMobile.classList.remove("flex-1");
            pleinButtonMobile.querySelector("h3").classList.add("hidden");
            pleinButtonMobile.querySelector("img").classList.remove("hidden");
            showPlein();
        });
    }
    if (parkButtonMobile) {
        parkButtonMobile.addEventListener("click", () => {
            [pleinButtonMobile, bosButtonMobile].forEach((otherButton) => {
                resetMobileButton(otherButton);
            });
            parkButtonMobile.classList.add("bg-yellow");
            parkButtonMobile.classList.add("rounded-t");
            parkButtonMobile.classList.add("w-1/5");
            parkButtonMobile.classList.remove("flex-1");
            parkButtonMobile.querySelector("h3").classList.add("hidden");
            parkButtonMobile.querySelector("img").classList.remove("hidden");
            showPark();
        });
    }
    if (pleinButtonMobile) {
        bosButtonMobile.addEventListener("click", () => {
            [parkButtonMobile, pleinButtonMobile].forEach((otherButton) => {
                resetMobileButton(otherButton);
            });
            bosButtonMobile.classList.add("bg-yellow");
            bosButtonMobile.classList.add("rounded-tl");
            bosButtonMobile.classList.add("w-1/5");
            bosButtonMobile.classList.remove("flex-1");
            bosButtonMobile.querySelector("h3").classList.add("hidden");
            bosButtonMobile.querySelector("img").classList.remove("hidden");
            showBos();
        });
    }
}

function resetMobileButton(button) {
    button.classList.add("flex-1");
    button.classList.add("cursor-pointer");
    button.classList.remove("bg-yellow");
    button.classList.remove("rounded-t");
    button.classList.remove("rounded-tr");
    button.classList.remove("rounded-tl");
    button.classList.remove("w-1/5");
    button.querySelector("h3").classList.remove("hidden");
    button.querySelector("img").classList.add("hidden");
}

function showPark() {
    const park = document.getElementById("park");
    const parkImages = document.getElementById("park-images");
    const plein = document.getElementById("plein");
    const pleinImages = document.getElementById("plein-images");
    const bos = document.getElementById("bos");
    const bosImages = document.getElementById("bos-images");

    [park, parkImages].forEach((element) => {
        if (!element) {
            return;
        }

        element.classList.remove("delay-100");
        element.classList.remove("opacity-0");
        element.classList.remove("pointer-events-none");
    });

    [plein, pleinImages, bosImages, bos].forEach((element) => {
        if (!element) {
            return;
        }

        element.classList.add("delay-100");
        element.classList.add("opacity-0");
        element.classList.add("pointer-events-none");
    });
}

function showPlein() {
    const park = document.getElementById("park");
    const parkImages = document.getElementById("park-images");
    const plein = document.getElementById("plein");
    const pleinImages = document.getElementById("plein-images");
    const bos = document.getElementById("bos");
    const bosImages = document.getElementById("bos-images");

    [plein, pleinImages].forEach((element) => {
        if (!element) {
            return;
        }

        element.classList.remove("delay-100");
        element.classList.remove("opacity-0");
        element.classList.remove("pointer-events-none");
    });

    [park, parkImages, bos, bosImages].forEach((element) => {
        if (!element) {
            return;
        }

        element.classList.add("delay-100");
        element.classList.add("opacity-0");
        element.classList.add("pointer-events-none");
    });
}

function showBos() {
    const park = document.getElementById("park");
    const parkImages = document.getElementById("park-images");
    const plein = document.getElementById("plein");
    const pleinImages = document.getElementById("plein-images");
    const bos = document.getElementById("bos");
    const bosImages = document.getElementById("bos-images");

    [bos, bosImages].forEach((element) => {
        if (!element) {
            return;
        }

        element.classList.remove("delay-100");
        element.classList.remove("opacity-0");
        element.classList.remove("pointer-events-none");
    });

    [plein, pleinImages, park, parkImages].forEach((element) => {
        if (!element) {
            return;
        }

        element.classList.add("delay-100");
        element.classList.add("opacity-0");
        element.classList.add("pointer-events-none");
    });
}

function nieuwsActionTabs() {
    // home page news / action tabs
    const nieuwsButton = document.getElementById("home-nieuws-button");
    const actiesButton = document.getElementById("home-acties-button");
    if (nieuwsButton) {
        nieuwsButton.addEventListener("click", () => {
            // change color tabs
            actiesButton.classList.remove("bg-white");
            nieuwsButton.classList.add("bg-white");
            // switch out content
            showNieuws();
        });
    }

    if (actiesButton) {
        actiesButton.addEventListener("click", () => {
            // change color tabs
            nieuwsButton.classList.remove("bg-white");
            actiesButton.classList.add("bg-white");
            // switch out content
            showActies();
        });
    }

    // home page news / action tabs
    const nieuwsButtonMobile = document.getElementById("home-nieuws-button-mobile");
    const actiesButtonMobile = document.getElementById("home-acties-button-mobile");
    if (nieuwsButtonMobile) {
        nieuwsButtonMobile.addEventListener("click", () => {
            // change color tabs
            nieuwsButtonMobile.parentElement.classList.add("opacity-0");
            nieuwsButtonMobile.parentElement.classList.add("pointer-events-none");
            actiesButtonMobile.parentElement.classList.remove("opacity-0");
            actiesButtonMobile.parentElement.classList.remove("pointer-events-none");
            // switch out content
            showNieuws();
        });
    }

    if (actiesButtonMobile) {
        actiesButtonMobile.addEventListener("click", () => {
            // change color tabs
            nieuwsButtonMobile.parentElement.classList.remove("opacity-0");
            nieuwsButtonMobile.parentElement.classList.remove("pointer-events-none");
            actiesButtonMobile.parentElement.classList.add("opacity-0");
            actiesButtonMobile.parentElement.classList.add("pointer-events-none");
            // switch out content
            showActies();
        });
    }
}

function showNieuws() {
    const nieuws = document.getElementById("home-nieuws");
    nieuws.classList.remove("opacity-0");
    nieuws.classList.remove("pointer-events-none");
    const acties = document.getElementById("home-acties");
    acties.classList.add("opacity-0");
    acties.classList.add("pointer-events-none");
}

function showActies() {
    const nieuws = document.getElementById("home-nieuws");
    nieuws.classList.add("opacity-0");
    nieuws.classList.add("pointer-events-none");
    const acties = document.getElementById("home-acties");
    acties.classList.remove("opacity-0");
    acties.classList.remove("pointer-events-none");
}

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

function isHidden(el) {
    var style = window.getComputedStyle(el);
    return style.display === "none";
}
